
import {defineComponent} from 'vue';
import {useState} from "@/hooks/state";

const state = useState();

export default defineComponent({
  name: 'ActionButton',
  emits: ['click'],
  props: {
    text: {
      type: String,
      default: ''
    },
    rawtext: {
      type: String,
      default: ''
    },
    colorClass: {
      type: String,
      default: ''
    },
    buttonClass: {
      type: String,
      default: 'action-button'
    },
    selected: {
      type: Boolean,
      default: false
    },
    preicon: {
      type: String,
      default: ''
    },
    clickDisables: {
      type: Boolean,
      default: false
    },
    cornerIcon: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      state,
      disabled: false
    }
  },

  methods: {
    click() {
      if (!this.disabled) {
        this.$emit('click')
      }

      if (this.clickDisables) {
        this.disabled = true;
      }
    }
  }
});
